export default {
    computed: {
        pageTag() {
            
            let routeName = this.$store.state.route.name;            
            return routeName.replace(new RegExp('\\.', 'g'), '_');
        },
    },
};



// WEBPACK FOOTER //
// ./shared/mixins/tracking.js